/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useEffect } from 'react';

import { BROADCAST_TOPIC } from '@mythos/api/Topics';
import { subscribeToTopic, unsubscribeFromTopic } from './stores/channelStore';
import { useToastStore } from './stores/toastStore';

export default function Toaster() {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  useEffect(() => {
    // Subscribe the WS to the global broadcast topic so toast messages reach
    // this client. Routing happens by message type in channelStore, so the
    // callback here is a no-op.
    const subscription = subscribeToTopic(BROADCAST_TOPIC, () => {});
    return () => unsubscribeFromTopic(subscription);
  }, []);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div css={styles.container}>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          css={styles.toast}
          onClick={() => removeToast(toast.id)}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
}

const styles = {
  container: css({
    position: 'fixed',
    top: 16,
    right: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    zIndex: 10001,
    maxWidth: 360,
  }),
  toast: css({
    backgroundColor: 'rgb(40, 40, 48)',
    color: 'white',
    padding: '10px 14px',
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 500,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.35)',
    cursor: 'pointer',
    wordBreak: 'break-word',
  }),
};
